// import customerjson from './customers'
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { API_URL } from '../../ConstVariable';
import LogRecord from './LogRecord';
import LogSearch from '../../DeveloperPage/LogSearch';

const ConversationLogs = () => {
    const { conversation_id } = useParams()
    const [isLogFetching, setIsLogFetching] = useState(false)
    const [logs, setLogs] = useState([])

    document.title = `Logs:${conversation_id}`


    let token = localStorage.getItem("MyToken");


    const fetchLosg = () => {
        setIsLogFetching(true)
        axios({
            method: "get",
            url: `${API_URL}/oi/api/v1/logs/${conversation_id}`,
            // data: request_data,
            headers: {

                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            withCredentials: true
        })
            .then((response) => {
                setIsLogFetching(false)
                if (Array.isArray(response.data)) {

                    setLogs(response.data)
                } else {
                    setLogs([])

                }
            })
            .catch((error) => {
                setIsLogFetching(false)
                console.log("Error", error)
            });
    }

    useEffect(() => {
        // fetchLosg()
    }, [])

    return (
        <div style={{overflow:"scroll", width:"100%", height:"100vh", paddingLeft:5}}>
            <LogSearch conversationIdFromUrl={conversation_id} />
            {logs && logs.map((log, index) => {
                return (
                    <LogRecord key={"log_" + index} log={log}></LogRecord>
                )
            })}
        </div>
    )

}


export default ConversationLogs